/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-require-imports */
/* eslint-disable global-require */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';

// Conditional component for Tile that only exists in Alpha
// This handles the import issue for tests and Legacy mode
let TileComponent: React.ComponentType<any>;

// Create mock component that handles both link and button behaviors
const MockTileComponent = React.forwardRef<HTMLDivElement, any>(
  ({ children, href, target, rel, onClick, className, ...props }, ref) => {
    if (href) {
      return (
        <a
          ref={ref as any}
          href={href}
          target={target}
          rel={rel}
          onClick={onClick}
          className={className}
          {...props}
        >
          {children}
        </a>
      );
    }
    return (
      <div ref={ref} onClick={onClick} className={className} role="button" tabIndex={0} {...props}>
        {children}
      </div>
    );
  },
);

// In test environment or Legacy mode, use mock component
if (process.env.NODE_ENV === 'test' || process.env.IS_LEGACY) {
  MockTileComponent.displayName = 'MockTile';
  TileComponent = MockTileComponent;
} else {
  // Alpha mode - import the real Tile component
  try {
    const { Tile } = require('@oneaudi/unified-web-components');
    TileComponent = Tile;
  } catch {
    // Fallback to mock if Tile doesn't exist
    MockTileComponent.displayName = 'FallbackTile';
    TileComponent = MockTileComponent;
  }
}

export const Tile = TileComponent;
